import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { QuoteCompaisonGroupDatabase } from '../../../../types';
import { useQuoteGroupFormDialog } from './useQuoteGroupFormDialog';

type Props = {
  onClose: () => void;
  afterSuccess?: (group: QuoteCompaisonGroupDatabase) => void;
};

export default function QuoteGroupFormDialog(props: Props) {
  const hook = useQuoteGroupFormDialog(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      onSubmit={hook.onSubmit}
      maxWidth="sm"
      fullWidth
      title="Nouvelle comparaison de devis"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Créer la comparaison',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          control={hook.form.control}
          name="name"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom"
              placeholder="Ex. : Réfection de la toiture"
              fullWidth
              required
              autoFocus
              error={!!fieldState.error}
              helperText={fieldState.error?.message ?? 'Les critères Prix HT, Prix TTC et Commentaires sont ajoutés d\'office.'}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
